import FormField from 'components/FormField'
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import React, { useEffect, useState } from 'react'
import { useUpdateAccount } from "queries/accounts";

function ContactTab({ formData, handleRefresh })  {
    const [success, setsuccess] = useState("")
    const [currentFormData, setcurrentFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
    });

    // Sync currentFormData with formData when formData changes
    useEffect(() => {
        if (formData) {
            setcurrentFormData(formData);
        }
    }, [formData]);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setcurrentFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setsuccess('')
    };

    const { mutateAsync: updateAccount } = useUpdateAccount();

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            _id: currentFormData.id,
            business_name: currentFormData.business_name,
            city: currentFormData.city,
            website: currentFormData.website,
            country: currentFormData.country,
            state: currentFormData.state,
            zip_code: currentFormData.zip_code,
            time_zone: currentFormData.time_zone,
            address: currentFormData.address,
        };
        const { response } = await updateAccount(payload);
        if (response) {
            setsuccess("Data updated..!")
        }
    };
    return (
        <div>
            <p className='text-center'>{success}</p>

            <form onSubmit={handleSubmit}  >
                <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">Business Name</label>
                            <input className='form-control-agust' label="Business name" onChange={handleChange} placeholder="Name" name="business_name" value={currentFormData.business_name}
                            />
                        </SoftBox>
                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">City</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="city" name="city" value={currentFormData.city}
                            />
                        </SoftBox>

                    </div>
                    <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">Website</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="website" name="website" value={currentFormData.website}
                            />
                        </SoftBox>

                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">Country</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="country" name="country" value={currentFormData.country}
                            />
                        </SoftBox>
                    </div>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">State / Prov / Region</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="State / Prov / Region" name="state" value={currentFormData.state}
                            />
                        </SoftBox>
                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">Zip / Postal code</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="Zip / Postal code" name="zip_code" value={currentFormData.zip_code}
                            />
                        </SoftBox>
                    </div>
                    <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">Street address</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="address" name="address" value={currentFormData.address}
                            />
                        </SoftBox>

                        <SoftBox style={{ margin: "10px 0px " }}>
                            <label className="text-black">Time Zone</label>
                            <input className='form-control-agust' onChange={handleChange} placeholder="time zone" name="time_zone" value={currentFormData.time_zone}
                            />

                        </SoftBox>
                    </div>
                </div>
                <div style={{ margin: "10px 0px", textAlign: "right" }}>
                    <SoftButton type="submit" color="dark">
                        Update
                    </SoftButton>
                </div>
            </form>
        </div>
    )
}

export default ContactTab
